import styled from 'styled-components'
import ButtonView from 'components/button/ButtonView'

const getFontBoldFamily = props => props.theme.buttons.text.boldFamily
const getFontFamily = props => props.theme.buttons.text.family

const StyledButtonView = styled(ButtonView)`
  width: 100%;
  font-family: ${getFontFamily};
  padding: 1px;

  &:hover {
    font-family: ${getFontBoldFamily};
    padding: 0;
  }

  &:disabled,
  &[disabled],
  &:active {
    font-family: ${getFontFamily};
  }
`

export default StyledButtonView
